// @flow

import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import BoostTextExperiment from 'app/common/react/components/Business/BoostTextExperiment';
import i18n from 'app/common/lib/i18n';
import Testable from 'app/common/react/ui/Testable';
import { Button } from 'gestalt';
import { logQuickPromoteEvents } from 'app/common/lib/BusinessLoggingUtils';
import { showQuickPromoteModal } from 'app/common/redux/actions/quickPromote';
import { type Dispatch } from 'redux';

type ReduxDispatchProps = {|
  dispatch: Dispatch<any>,
|};

type OwnProps = {|
  component?: number, // Used for context logging only
  pin: {
    id: string,
  },
|};

type Props = {|
  ...OwnProps,
  ...ReduxDispatchProps,
|};

// Promote button owned by Advertiser Growth
export function PinPromoteButton({ component, dispatch, pin }: Props) {
  useEffect(() => {
    logQuickPromoteEvents(
      'render',
      'pin_rep',
      PCONST.thrift.EventType.RENDER,
      component || PCONST.thrift.ComponentType.FLOWED_PIN,
    );
  }, []);

  const handleClick = ({ event }) => {
    if (event) {
      event.stopPropagation();
      // This prevents the browser from navigating to links
      // when the Promote Button is embedded within one
      event.preventDefault();
    }

    logQuickPromoteEvents(
      'click',
      'pin_rep',
      PCONST.thrift.EventType.CLICK,
      component || PCONST.thrift.ComponentType.FLOWED_PIN,
    );

    dispatch(showQuickPromoteModal(pin));
  };

  return (
    <Testable id="quickpromote-button">
      <BoostTextExperiment>
        {({ anyEnabled }) => (
          <Button
            color="red"
            onClick={handleClick}
            text={
              anyEnabled
                ? i18n._('Boost', '[m10n] boost button for promoting a pin')
                : i18n._('Promote')
            }
          />
        )}
      </BoostTextExperiment>
    </Testable>
  );
}

export default connect<Props, OwnProps, _, _, _, _>()(PinPromoteButton);
